import { render, staticRenderFns } from "./default-checkbox.vue?vue&type=template&id=71bd22f6&scoped=true&"
import script from "./default-checkbox.vue?vue&type=script&lang=js&"
export * from "./default-checkbox.vue?vue&type=script&lang=js&"
import style0 from "./default-checkbox.vue?vue&type=style&index=0&id=71bd22f6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71bd22f6",
  null
  
)

export default component.exports